import React, { useContext } from 'react';
import './Inventory.css';
import GameAssetsContext from '../../../../../context/GameAssetContext';

interface InventoryProps {
  itemIds?: string[];
  bootsSlotItem?: string | null;
  hasBotBootsSlot?: boolean;
}

const Inventory: React.FC<InventoryProps> = ({ itemIds = [], bootsSlotItem = null, hasBotBootsSlot = false }) => {
  const { gameWideAssets } = useContext(GameAssetsContext);
  const { itemImages } = gameWideAssets;

  // Determine total slot count: 7 for Bot lane quest, 6 otherwise
  const totalSlots = hasBotBootsSlot ? 7 : 6;

  // Build the full item list: main items + boots slot item (if bot quest)
  const slots = [...itemIds];
  if (hasBotBootsSlot && bootsSlotItem) {
    slots.push(bootsSlotItem);
  }
  while (slots.length < totalSlots) {
    slots.push('');
  }

  return (
    <div className="champion-inventory">
      <div className={`champion-item-slots ${hasBotBootsSlot ? 'with-boots-slot' : ''}`}>
        {slots.map((itemId, index) => (
          <div key={index} className="champion-item-slot">
            {itemId && <img src={itemImages[itemId]} alt={`${itemId}`} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Inventory;
